// ============================================================================
// DENS CAKRA — Sumber Data Operasional Nasional (Single Source of Truth)
// Data dummy realistis untuk 38 Provinsi / BINDA Indonesia.
// Dikonsumsi oleh Peta Operasi Nasional, Dashboard Eksekutif, Command Center.
// ============================================================================

export type StatusWilayah = 'Normal' | 'Perhatian' | 'Waspada' | 'Kritis'

export interface Binda {
  kode: string
  binda: string
  provinsi: string
  lat: number
  lng: number
  personelAktif: number
  laporanHariIni: number
  laporanPrioritas: number
  laporanDarurat: number
  kpiWilayah: number
  status: StatusWilayah
  kepala: string
}

// Warna status wilayah → token tema
export const STATUS_META: Record<
  StatusWilayah,
  { label: string; color: string; dot: string }
> = {
  Normal: { label: 'Normal', color: 'var(--status-active)', dot: '🟢' },
  Perhatian: { label: 'Perhatian', color: 'var(--status-info)', dot: '🟡' },
  Waspada: { label: 'Waspada', color: 'var(--status-standby)', dot: '🟠' },
  Kritis: { label: 'Kritis', color: 'var(--destructive)', dot: '🔴' },
}

export function statusColor(status: StatusWilayah): string {
  return STATUS_META[status].color
}

// 38 BINDA — koordinat ibu kota provinsi, statistik operasional realistis.
export const BINDA_LIST: Binda[] = [
  {
    kode: 'BINDA-AC',
    binda: 'BINDA Aceh',
    provinsi: 'Aceh',
    lat: 5.5483,
    lng: 95.3238,
    personelAktif: 246,
    laporanHariIni: 58,
    laporanPrioritas: 5,
    laporanDarurat: 0,
    kpiWilayah: 87,
    status: 'Waspada',
    kepala: 'Brigjen Teuku Iskandar',
  },
  {
    kode: 'BINDA-SU',
    binda: 'BINDA Sumatera Utara',
    provinsi: 'Sumatera Utara',
    lat: 3.5952,
    lng: 98.6722,
    personelAktif: 324,
    laporanHariIni: 87,
    laporanPrioritas: 6,
    laporanDarurat: 0,
    kpiWilayah: 91,
    status: 'Normal',
    kepala: 'Brigjen Daud Siregar',
  },
  {
    kode: 'BINDA-SB',
    binda: 'BINDA Sumatera Barat',
    provinsi: 'Sumatera Barat',
    lat: -0.9471,
    lng: 100.4172,
    personelAktif: 198,
    laporanHariIni: 44,
    laporanPrioritas: 3,
    laporanDarurat: 0,
    kpiWilayah: 89,
    status: 'Normal',
    kepala: 'Kolonel Inf. Bagus Pratama',
  },
  {
    kode: 'BINDA-RI',
    binda: 'BINDA Riau',
    provinsi: 'Riau',
    lat: 0.5071,
    lng: 101.4478,
    personelAktif: 212,
    laporanHariIni: 53,
    laporanPrioritas: 3,
    laporanDarurat: 0,
    kpiWilayah: 88,
    status: 'Normal',
    kepala: 'Brigjen Rizal Maulana',
  },
  {
    kode: 'BINDA-KR',
    binda: 'BINDA Kepulauan Riau',
    provinsi: 'Kepulauan Riau',
    lat: 0.9189,
    lng: 104.4669,
    personelAktif: 167,
    laporanHariIni: 39,
    laporanPrioritas: 4,
    laporanDarurat: 1,
    kpiWilayah: 86,
    status: 'Perhatian',
    kepala: 'Kolonel Laut Hendra Wijaya',
  },
  {
    kode: 'BINDA-JA',
    binda: 'BINDA Jambi',
    provinsi: 'Jambi',
    lat: -1.6101,
    lng: 103.6131,
    personelAktif: 154,
    laporanHariIni: 31,
    laporanPrioritas: 2,
    laporanDarurat: 0,
    kpiWilayah: 90,
    status: 'Normal',
    kepala: 'Kolonel Inf. Surya Atmaja',
  },
  {
    kode: 'BINDA-SS',
    binda: 'BINDA Sumatera Selatan',
    provinsi: 'Sumatera Selatan',
    lat: -2.9909,
    lng: 104.7566,
    personelAktif: 231,
    laporanHariIni: 57,
    laporanPrioritas: 4,
    laporanDarurat: 0,
    kpiWilayah: 88,
    status: 'Normal',
    kepala: 'Brigjen Marwan Hidayat',
  },
  {
    kode: 'BINDA-BE',
    binda: 'BINDA Bengkulu',
    provinsi: 'Bengkulu',
    lat: -3.8004,
    lng: 102.2655,
    personelAktif: 121,
    laporanHariIni: 24,
    laporanPrioritas: 1,
    laporanDarurat: 0,
    kpiWilayah: 91,
    status: 'Normal',
    kepala: 'Kolonel Inf. Galih Saputra',
  },
  {
    kode: 'BINDA-LA',
    binda: 'BINDA Lampung',
    provinsi: 'Lampung',
    lat: -5.4501,
    lng: 105.2668,
    personelAktif: 203,
    laporanHariIni: 49,
    laporanPrioritas: 3,
    laporanDarurat: 0,
    kpiWilayah: 89,
    status: 'Normal',
    kepala: 'Brigjen Anton Wibowo',
  },
  {
    kode: 'BINDA-BB',
    binda: 'BINDA Bangka Belitung',
    provinsi: 'Kepulauan Bangka Belitung',
    lat: -2.1316,
    lng: 106.1169,
    personelAktif: 109,
    laporanHariIni: 22,
    laporanPrioritas: 1,
    laporanDarurat: 0,
    kpiWilayah: 92,
    status: 'Normal',
    kepala: 'Kolonel Laut Bayu Anggara',
  },
  {
    kode: 'BINDA-JK',
    binda: 'BINDA DKI Jakarta',
    provinsi: 'DKI Jakarta',
    lat: -6.2088,
    lng: 106.8456,
    personelAktif: 712,
    laporanHariIni: 168,
    laporanPrioritas: 14,
    laporanDarurat: 2,
    kpiWilayah: 90,
    status: 'Waspada',
    kepala: 'Mayjen Bambang Sutrisno',
  },
  {
    kode: 'BINDA-BT',
    binda: 'BINDA Banten',
    provinsi: 'Banten',
    lat: -6.4058,
    lng: 106.064,
    personelAktif: 287,
    laporanHariIni: 64,
    laporanPrioritas: 5,
    laporanDarurat: 0,
    kpiWilayah: 88,
    status: 'Perhatian',
    kepala: 'Brigjen Hadi Nugroho',
  },
  {
    kode: 'BINDA-JB',
    binda: 'BINDA Jawa Barat',
    provinsi: 'Jawa Barat',
    lat: -6.9147,
    lng: 107.6098,
    personelAktif: 645,
    laporanHariIni: 142,
    laporanPrioritas: 11,
    laporanDarurat: 1,
    kpiWilayah: 93,
    status: 'Perhatian',
    kepala: 'Mayjen Dedi Kurniawan',
  },
  {
    kode: 'BINDA-JT',
    binda: 'BINDA Jawa Tengah',
    provinsi: 'Jawa Tengah',
    lat: -7.0051,
    lng: 110.4381,
    personelAktif: 598,
    laporanHariIni: 131,
    laporanPrioritas: 9,
    laporanDarurat: 0,
    kpiWilayah: 92,
    status: 'Normal',
    kepala: 'Mayjen Joko Prasetyo',
  },
  {
    kode: 'BINDA-YO',
    binda: 'BINDA DI Yogyakarta',
    provinsi: 'DI Yogyakarta',
    lat: -7.7956,
    lng: 110.3695,
    personelAktif: 234,
    laporanHariIni: 52,
    laporanPrioritas: 3,
    laporanDarurat: 0,
    kpiWilayah: 94,
    status: 'Normal',
    kepala: 'Brigjen Raden Wirasena',
  },
  {
    kode: 'BINDA-JI',
    binda: 'BINDA Jawa Timur',
    provinsi: 'Jawa Timur',
    lat: -7.2575,
    lng: 112.7521,
    personelAktif: 631,
    laporanHariIni: 138,
    laporanPrioritas: 10,
    laporanDarurat: 1,
    kpiWilayah: 91,
    status: 'Perhatian',
    kepala: 'Mayjen Eko Santoso',
  },
  {
    kode: 'BINDA-BA',
    binda: 'BINDA Bali',
    provinsi: 'Bali',
    lat: -8.4095,
    lng: 115.1889,
    personelAktif: 276,
    laporanHariIni: 61,
    laporanPrioritas: 6,
    laporanDarurat: 0,
    kpiWilayah: 90,
    status: 'Perhatian',
    kepala: 'Brigjen Made Suarjana',
  },
  {
    kode: 'BINDA-NB',
    binda: 'BINDA NTB',
    provinsi: 'Nusa Tenggara Barat',
    lat: -8.6529,
    lng: 117.3616,
    personelAktif: 178,
    laporanHariIni: 38,
    laporanPrioritas: 3,
    laporanDarurat: 0,
    kpiWilayah: 87,
    status: 'Normal',
    kepala: 'Kolonel Inf. Lalu Hamzah',
  },
  {
    kode: 'BINDA-NT',
    binda: 'BINDA NTT',
    provinsi: 'Nusa Tenggara Timur',
    lat: -10.1772,
    lng: 123.607,
    personelAktif: 165,
    laporanHariIni: 41,
    laporanPrioritas: 5,
    laporanDarurat: 1,
    kpiWilayah: 84,
    status: 'Waspada',
    kepala: 'Brigjen Yohanes Tefa',
  },
  {
    kode: 'BINDA-KB',
    binda: 'BINDA Kalimantan Barat',
    provinsi: 'Kalimantan Barat',
    lat: -0.0263,
    lng: 109.3425,
    personelAktif: 189,
    laporanHariIni: 43,
    laporanPrioritas: 4,
    laporanDarurat: 0,
    kpiWilayah: 88,
    status: 'Perhatian',
    kepala: 'Brigjen Firman Sanjaya',
  },
  {
    kode: 'BINDA-KT',
    binda: 'BINDA Kalimantan Tengah',
    provinsi: 'Kalimantan Tengah',
    lat: -2.2096,
    lng: 113.9108,
    personelAktif: 142,
    laporanHariIni: 30,
    laporanPrioritas: 2,
    laporanDarurat: 0,
    kpiWilayah: 89,
    status: 'Normal',
    kepala: 'Kolonel Inf. Doni Hartanto',
  },
  {
    kode: 'BINDA-KS',
    binda: 'BINDA Kalimantan Selatan',
    provinsi: 'Kalimantan Selatan',
    lat: -3.3194,
    lng: 114.5908,
    personelAktif: 168,
    laporanHariIni: 37,
    laporanPrioritas: 3,
    laporanDarurat: 0,
    kpiWilayah: 90,
    status: 'Normal',
    kepala: 'Brigjen Yusuf Ramli',
  },
  {
    kode: 'BINDA-KI',
    binda: 'BINDA Kalimantan Timur',
    provinsi: 'Kalimantan Timur',
    lat: -0.5022,
    lng: 117.1536,
    personelAktif: 254,
    laporanHariIni: 59,
    laporanPrioritas: 6,
    laporanDarurat: 1,
    kpiWilayah: 92,
    status: 'Perhatian',
    kepala: 'Mayjen Arif Budiman',
  },
  {
    kode: 'BINDA-KU',
    binda: 'BINDA Kalimantan Utara',
    provinsi: 'Kalimantan Utara',
    lat: 2.8341,
    lng: 117.3854,
    personelAktif: 118,
    laporanHariIni: 26,
    laporanPrioritas: 2,
    laporanDarurat: 0,
    kpiWilayah: 86,
    status: 'Normal',
    kepala: 'Kolonel Inf. Reza Pahlevi',
  },
  {
    kode: 'BINDA-SA',
    binda: 'BINDA Sulawesi Utara',
    provinsi: 'Sulawesi Utara',
    lat: 1.4748,
    lng: 124.8421,
    personelAktif: 176,
    laporanHariIni: 40,
    laporanPrioritas: 3,
    laporanDarurat: 0,
    kpiWilayah: 89,
    status: 'Normal',
    kepala: 'Brigjen Ronald Tumbelaka',
  },
  {
    kode: 'BINDA-GO',
    binda: 'BINDA Gorontalo',
    provinsi: 'Gorontalo',
    lat: 0.5435,
    lng: 123.0568,
    personelAktif: 98,
    laporanHariIni: 19,
    laporanPrioritas: 1,
    laporanDarurat: 0,
    kpiWilayah: 91,
    status: 'Normal',
    kepala: 'Kolonel Inf. Yusran Habibie',
  },
  {
    kode: 'BINDA-ST',
    binda: 'BINDA Sulawesi Tengah',
    provinsi: 'Sulawesi Tengah',
    lat: -0.8917,
    lng: 119.8707,
    personelAktif: 187,
    laporanHariIni: 47,
    laporanPrioritas: 6,
    laporanDarurat: 1,
    kpiWilayah: 83,
    status: 'Waspada',
    kepala: 'Brigjen Sahrul Mamonto',
  },
  {
    kode: 'BINDA-SR',
    binda: 'BINDA Sulawesi Barat',
    provinsi: 'Sulawesi Barat',
    lat: -2.6747,
    lng: 118.8869,
    personelAktif: 104,
    laporanHariIni: 23,
    laporanPrioritas: 1,
    laporanDarurat: 0,
    kpiWilayah: 88,
    status: 'Normal',
    kepala: 'Kolonel Inf. Asri Tahir',
  },
  {
    kode: 'BINDA-SE',
    binda: 'BINDA Sulawesi Selatan',
    provinsi: 'Sulawesi Selatan',
    lat: -5.1477,
    lng: 119.4327,
    personelAktif: 312,
    laporanHariIni: 78,
    laporanPrioritas: 7,
    laporanDarurat: 0,
    kpiWilayah: 91,
    status: 'Normal',
    kepala: 'Mayjen Andi Mappanyukki',
  },
  {
    kode: 'BINDA-SG',
    binda: 'BINDA Sulawesi Tenggara',
    provinsi: 'Sulawesi Tenggara',
    lat: -3.9985,
    lng: 122.513,
    personelAktif: 143,
    laporanHariIni: 33,
    laporanPrioritas: 3,
    laporanDarurat: 0,
    kpiWilayah: 87,
    status: 'Normal',
    kepala: 'Kolonel Inf. La Ode Karim',
  },
  {
    kode: 'BINDA-MA',
    binda: 'BINDA Maluku',
    provinsi: 'Maluku',
    lat: -3.6954,
    lng: 128.1814,
    personelAktif: 137,
    laporanHariIni: 34,
    laporanPrioritas: 4,
    laporanDarurat: 0,
    kpiWilayah: 85,
    status: 'Perhatian',
    kepala: 'Brigjen Frans Latuihamallo',
  },
  {
    kode: 'BINDA-MU',
    binda: 'BINDA Maluku Utara',
    provinsi: 'Maluku Utara',
    lat: 0.7785,
    lng: 127.3825,
    personelAktif: 112,
    laporanHariIni: 27,
    laporanPrioritas: 2,
    laporanDarurat: 0,
    kpiWilayah: 86,
    status: 'Normal',
    kepala: 'Kolonel Inf. Rahmat Saleh',
  },
  {
    kode: 'BINDA-PA',
    binda: 'BINDA Papua',
    provinsi: 'Papua',
    lat: -2.5337,
    lng: 140.7181,
    personelAktif: 198,
    laporanHariIni: 74,
    laporanPrioritas: 12,
    laporanDarurat: 1,
    kpiWilayah: 84,
    status: 'Waspada',
    kepala: 'Mayjen Yusuf Wonda',
  },
  {
    kode: 'BINDA-PB',
    binda: 'BINDA Papua Barat',
    provinsi: 'Papua Barat',
    lat: -0.8615,
    lng: 134.062,
    personelAktif: 134,
    laporanHariIni: 48,
    laporanPrioritas: 7,
    laporanDarurat: 1,
    kpiWilayah: 82,
    status: 'Waspada',
    kepala: 'Brigjen Marthen Rumbiak',
  },
  {
    kode: 'BINDA-PD',
    binda: 'BINDA Papua Barat Daya',
    provinsi: 'Papua Barat Daya',
    lat: -0.8762,
    lng: 131.2558,
    personelAktif: 96,
    laporanHariIni: 35,
    laporanPrioritas: 5,
    laporanDarurat: 0,
    kpiWilayah: 81,
    status: 'Perhatian',
    kepala: 'Kolonel Inf. Sem Mandacan',
  },
  {
    kode: 'BINDA-PS',
    binda: 'BINDA Papua Selatan',
    provinsi: 'Papua Selatan',
    lat: -8.4932,
    lng: 140.4019,
    personelAktif: 89,
    laporanHariIni: 41,
    laporanPrioritas: 8,
    laporanDarurat: 1,
    kpiWilayah: 79,
    status: 'Kritis',
    kepala: 'Brigjen Petrus Gebze',
  },
  {
    kode: 'BINDA-PT',
    binda: 'BINDA Papua Tengah',
    provinsi: 'Papua Tengah',
    lat: -3.7505,
    lng: 136.8884,
    personelAktif: 112,
    laporanHariIni: 56,
    laporanPrioritas: 11,
    laporanDarurat: 2,
    kpiWilayah: 76,
    status: 'Kritis',
    kepala: 'Mayjen Lukas Enembe',
  },
  {
    kode: 'BINDA-PG',
    binda: 'BINDA Papua Pegunungan',
    provinsi: 'Papua Pegunungan',
    lat: -4.0855,
    lng: 138.9415,
    personelAktif: 102,
    laporanHariIni: 50,
    laporanPrioritas: 10,
    laporanDarurat: 1,
    kpiWilayah: 78,
    status: 'Waspada',
    kepala: 'Brigjen Natalis Tabuni',
  },
]

// ---------------------------------------------------------------------------
// Agregat Nasional — dikunci agar konsisten dengan spesifikasi operasional.
// ---------------------------------------------------------------------------
export const NASIONAL = {
  totalBinda: 38,
  totalPersonelAktif: 8742,
  laporanHariIni: 2183,
  laporanPrioritas: 117,
  laporanDarurat: 8,
  kpiNasional: 89,
  wilayahKritis: 2,
  wilayahWaspada: 5,
  wilayahPerhatian: 9,
  wilayahNormal: 22,
}

// Kategori laporan resmi (intelijen / monitoring).
export const KATEGORI_LAPORAN = [
  'Politik',
  'Sosial',
  'Ekonomi',
  'Keamanan',
  'Siber',
  'Terorisme',
  'Separatisme',
  'Konflik Sosial',
  'Objek Vital Nasional',
  'Infrastruktur Strategis',
  'Bencana',
  'Lintas Negara',
] as const

export type KategoriLaporan = (typeof KATEGORI_LAPORAN)[number]

// Alur kerja laporan (status workflow).
export const ALUR_LAPORAN = [
  'Draft',
  'Dikirim',
  'Review Koordinator',
  'Diverifikasi',
  'Analisis',
  'Disetujui BINDA',
  'Perlu Revisi',
  'Diterima Nasional',
  'Tindak Lanjut',
  'Selesai',
] as const

export type StatusLaporan = (typeof ALUR_LAPORAN)[number]

// Distribusi kategori laporan (untuk pie/bar chart distribusi).
export const DISTRIBUSI_KATEGORI: {
  kategori: KategoriLaporan
  jumlah: number
}[] = [
  { kategori: 'Keamanan', jumlah: 412 },
  { kategori: 'Sosial', jumlah: 318 },
  { kategori: 'Politik', jumlah: 287 },
  { kategori: 'Konflik Sosial', jumlah: 196 },
  { kategori: 'Ekonomi', jumlah: 174 },
  { kategori: 'Siber', jumlah: 158 },
  { kategori: 'Objek Vital Nasional', jumlah: 142 },
  { kategori: 'Separatisme', jumlah: 128 },
  { kategori: 'Infrastruktur Strategis', jumlah: 116 },
  { kategori: 'Bencana', jumlah: 98 },
  { kategori: 'Terorisme', jumlah: 84 },
  { kategori: 'Lintas Negara', jumlah: 70 },
]

// Tren laporan 7 hari (Senin–Minggu).
export const TREN_7_HARI = [
  { hari: 'Sen', laporan: 1985, prioritas: 92, darurat: 4 },
  { hari: 'Sel', laporan: 2104, prioritas: 101, darurat: 6 },
  { hari: 'Rab', laporan: 2056, prioritas: 88, darurat: 5 },
  { hari: 'Kam', laporan: 2231, prioritas: 110, darurat: 7 },
  { hari: 'Jum', laporan: 2342, prioritas: 124, darurat: 9 },
  { hari: 'Sab', laporan: 1876, prioritas: 78, darurat: 3 },
  { hari: 'Min', laporan: 2183, prioritas: 117, darurat: 8 },
]

// Tren laporan 30 hari (agregat mingguan + harian ringkas).
export const TREN_30_HARI = Array.from({ length: 30 }, (_, i) => {
  const base =
    1900 + Math.round(Math.sin(i / 3) * 180) + (i % 7 === 4 ? 260 : 0)
  return {
    hari: `H-${30 - i}`,
    laporan: base,
    prioritas: 70 + Math.round(Math.abs(Math.sin(i / 2)) * 55),
  }
})

// Top 10 Wilayah Prioritas (berdasarkan laporan prioritas).
export const TOP_PRIORITAS = [...BINDA_LIST]
  .sort((a, b) => b.laporanPrioritas - a.laporanPrioritas)
  .slice(0, 10)

// Top 10 BINDA Teraktif (berdasarkan laporan hari ini).
export const TOP_TERAKTIF = [...BINDA_LIST]
  .sort((a, b) => b.laporanHariIni - a.laporanHariIni)
  .slice(0, 10)

// Helper untuk filter status di peta/legenda.
export const SEMUA_STATUS: StatusWilayah[] = [
  'Normal',
  'Perhatian',
  'Waspada',
  'Kritis',
]
